document.addEventListener('DOMContentLoaded', () => {
  // Función para actualizar el contador global del carrito
  const updateCartBundle = async () => {
    try {
      const cartResponse = await fetch('/cart.js', {
        method: 'GET',
        credentials: 'same-origin'
      });
      if (cartResponse.ok) {
        const updatedCart = await cartResponse.json();
        const cartBubble = document.querySelector('.cart-count-bubble');
        if (cartBubble) {
          cartBubble.textContent = updatedCart.item_count;
        }
      } else {
        console.error('Error al obtener el carrito, status:', cartResponse.status);
      }
    } catch (error) {
      console.error('Error al actualizar el contador del carrito:', error);
    }
  };

  document.addEventListener('click', async (event) => {
    // Buscamos el botón de "Agregar al carrito"
    const button = event.target.closest('.home-add-to-cart');
    if (!button) return;

    // Obtenemos el contenedor donde se encuentra el <select>
    const container = button.closest('.custom-most-loved__info-container');
    if (!container) return;

    // Obtenemos el ID de la variante desde el <select>
    // Asegúrate de que cada <option> del <select> tenga en "value" el variant.id
    const tallaSelect = container.querySelector('.talla-select');
    if (!tallaSelect) {
      console.error('No se encontró el <select> con la clase .talla-select');
      return;
    }
    const variantId = tallaSelect.value; // El ID real de la variante
    if (!variantId) {
      console.error('No se pudo determinar la variante seleccionada');
      return;
    }

    // Extraemos datos adicionales del producto (para mostrarlos en la tarjeta)
    const productTitle = button.getAttribute('data-product-title') || '';
    const productVendor = button.getAttribute('data-product-vendor') || '';
    const productPrice = button.getAttribute('data-product-price') || '';
    const productImage = button.getAttribute('data-product-image') || '';
    const productVariant = button.getAttribute('data-product-variant') || '';
    const productImageAlt = button.getAttribute('data-product-image-alt') || '';

    // Tomamos la talla para mostrarla en la tarjeta (opcional),
    // pero ya NO la usamos como line item property
    const selectedSize = tallaSelect.options[tallaSelect.selectedIndex].text;

    try {
      // Construimos los parámetros para /cart/add.js
      const params = new URLSearchParams();
      params.append('id', variantId); // ID de la variante seleccionada
      params.append('quantity', 1);

      // Petición AJAX a Shopify
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        credentials: 'same-origin',
        body: params.toString(),
      });

      if (addResponse.ok) {
        // Construimos la tarjeta HTML con la info del producto
        const newCardHTML = `
          <div class="cart-notification-product">
            ${productImage
            ? `
                  <div class="cart-notification-product__image-2 global-media-settings">
                    <img src="${productImage}" alt="${productImageAlt}" class="img-product" width="230" loading="lazy">
                    <div class="cart-notification__text-container">
                      ${productVendor
              ? `<p class="caption-with-letter-spacing light">${productVendor}</p>`
              : ''
            }
                      <h3 class="cart-notification-product__name h4">
                        ${productTitle} has been added to your cart
                      </h3>
                      <dl>
                        <div class="cart-notifitacion__option-container">
                          <div class="product-option">
                            ${productPrice}
                          </div>
                          <div class="product-option">
                            Color: ${productVariant}
                          </div>
                          <div class="product-option">
                            Size: ${selectedSize}
                          </div>
                        </div>
                      </dl>
                    </div>
                  </div>
                `
            : ''
          }
          </div>
        `;

        // Insertamos la nueva tarjeta en el contenedor deseado
        const notificationProductDiv = document.getElementById('cart-notification-product-2');
        if (notificationProductDiv) {
          notificationProductDiv.innerHTML += newCardHTML;
        }

        // Finalmente, actualizamos el contador global del carrito
        updateCartBundle();
      } else {
        console.error('Error al agregar el producto, status:', addResponse.status);
      }
    } catch (error) {
      console.error('Error en la petición:', error);
    }
  });
});